// Add supported routes for mapping here
import {
  TellentClientHomepageID,
  TellentClientOneDomainLegacyRedirect,
  TellentClientSettingsHomepageID,
  TellentNavigationAppKind,
} from './client-navigation';

export type TellentAppRouting = {
  [key in TellentAppRouteID]: TellentPageConfig<key>;
};

export type TellentAppRouteID =
  | 'home'
  | 'billing'
  | 'buy_sso'
  | 'calendar'
  | 'employee_list'
  | 'employee_future_documents'
  | 'reviews'
  | 'campaigns'
  | 'skills'
  | 'training'
  | 'goals'
  | 'people'
  | 'careers'
  | 'careers_editor'
  | 'referrals'
  | 'intelligence'
  | 'departments'
  | 'ask:tickets'
  | 'ask:templates'
  | 'ask:my_tickets'
  | 'ask:new_ticket'
  | 'ask:ticket'
  | 'mailbox'
  | 'journeys:create'
  | 'journeys:create_bulk'
  | typeof TellentClientSettingsHomepageID
  | typeof TellentClientHomepageID
  | typeof TellentClientOneDomainLegacyRedirect;

export type TellentAppRouteParams = {
  'ask:new_ticket': {
    template_id: number;
  };
  [TellentClientOneDomainLegacyRedirect]: {
    path: `tellent://${string}`;
  };
  'journeys:create': {
    tellentMemberGuid: string;
  };
  'journeys:create_bulk': {
    tellentMemberGuids: string[];
  };
};

export type TellentAppKindParam = TellentNavigationAppKind;
export type TellentPageConfig<ID extends TellentAppRouteID> = ID extends keyof TellentAppRouteParams
  ? {
      id: ID;
      params: TellentAppRouteParams[ID];
    }
  : {
      id: ID;
    };
